module.exports = __webpack_public_path__ + "static/img/Matt-Moylan.1d0f7f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Moylan.jpg
// module id = wvaD
// module chunks = 0